import { render } from "./About.vue?vue&type=template&id=05cf181a&bindings={}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script